import set from 'lodash/set'
import { useSearchParams } from 'next/navigation'
import { useMemo } from 'react'

export function useQueryParams<T extends Record<string, any> = Record<string, any>>() {
  const searchParams = useSearchParams()

  const queryParams: T = useMemo(() => {
    const searchEntries = Array.from(searchParams?.entries?.() ?? [])
    return searchEntries.reduce((acc, cur) => {
      const [key, value] = cur
      set(acc, key, decodeURI(value))
      return acc
    }, {} as T)
  }, [searchParams])

  return queryParams
}
